import styled, { css } from 'styled-components';

export default styled.div`
  ${({ $rowLayout }) => $rowLayout && css`
    padding-bottom: ${({ theme }) => theme.grid.columnGap};
    display: grid;
    grid-auto-rows: auto;
    grid-gap: 1rem;
    grid-template-columns: 1fr;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      grid-template-columns:${({ $columns = '1fr 2fr' }) => $columns};
    }
  `}
`;
